module.exports = __webpack_public_path__ + "media/images/prizes__first-20076e98efd29566c2b2d656d87839eb.jpg";